import React from 'react';

import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { withSelector } from '../../../../shared/withSelector.js';
import Image from '../../Image/Image.js';
import { CAROUSEL_CATEGORY_KEY, CAROUSEL_COMPONENT_KEY } from '../Carousel.meta.js';
import { INavProps } from '../models/INavProps.js';

const Nav = (props: INavProps) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { className, children = '', navIcon, configuration, ...divProps } = props;
	const alt = typeof children === 'string' ? children : '';
	const Div: any = withSelector('div' as any, divProps);
	return (
		<Div className={className} {...divProps}>
			<Image asset={navIcon} className={className} alt={alt} />
		</Div>
	);
};

export default InjectedStyledComponent(Nav, CAROUSEL_CATEGORY_KEY, CAROUSEL_COMPONENT_KEY, ['nav']);
